var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.32334 0 0.833336 5 0.833336 5C0.833336 5 4.32334 10 10 10C15.6767 10 19.1667 5 19.1667 5C19.1667 5 15.6767 0 10 0ZM10 8.33333C6.71417 8.33333 4.22834 6.26333 3.01667 5C3.88334 4.09583 5.4025 2.78583 7.39584 2.10833C6.92677 2.69211 6.66969 3.41779 6.66667 4.16667C6.66667 6.00833 8.15834 7.5 10 7.5C11.8417 7.5 13.3333 6.00833 13.3333 4.16667C13.3333 3.38583 13.0542 2.6775 12.6042 2.10833C14.5983 2.78583 16.1175 4.09667 16.9825 5C15.7692 6.265 13.2842 8.33333 9.99917 8.33333H10Z",
    fill: "#457B9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobEyeOpen);
export default __webpack_public_path__ + "static/media/mob_eye_open.742badcce2ebbdba1bab668dc2ee23f2.svg";
export { ForwardRef as ReactComponent };